import { setLanguage } from './runtime.js';
import shellEs from './i18n/catalog-shell.es.js';
import shellEn from './i18n/catalog-shell.en.js';

const SUPPORTED = ['es', 'en'];
const STORAGE_KEY = 'sctmgutils.lang';
const COPY = { es: shellEs, en: shellEn };

function readLanguage() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(value) ? value : 'es';
  } catch (_) {
    return 'es';
  }
}

function persistLanguage(value) {
  try { localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
}

function paint(selector, language) {
  document.documentElement.lang = language;
  selector.setAttribute('aria-label', language === 'es' ? 'Cambiar idioma' : 'Change language');
  selector.querySelectorAll('.lang-selector-btn').forEach((button) => {
    const active = button.dataset.lang === language;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  document.querySelectorAll('[data-shell-i18n]').forEach((node) => {
    const value = COPY[language][node.dataset.shellI18n];
    if (value) node.textContent = value;
  });
}

export function setupLanguageSelector() {
  const selector = document.getElementById('sctmg-lang-selector');
  if (!selector) return 'es';

  let language = readLanguage();
  paint(selector, language);

  selector.addEventListener('click', async (event) => {
    const button = event.target.closest('.lang-selector-btn[data-lang]');
    if (!button || !selector.contains(button)) return;
    const next = button.dataset.lang;
    if (!SUPPORTED.includes(next) || next === language) return;
    language = next;
    persistLanguage(language);
    paint(selector, language);
    await setLanguage(language);
  });

  return language;
}
